/**
 * Event wrapper for `negotiationneeded` event.
 * Reference: developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/onnegotiationneeded
 * @method onnegotiationneeded
 * @param  {Function} listener The listener function for the event.
 * @return {Boolean}  Whether the assignment succeeded or not.
 */
export default function onnegotiationneeded (listener) {
  const { nativePeer, log } = this

  nativePeer.onnegotiationneeded = function (event) {
    log.debug('Peer received negotiationneeded event.')
    listener(event)
  }

  return true
}
